<style lang="scss" scoped>
img {
  max-width: 100%;
}
.img-mod {
  max-height: 150px;
  max-width: 300px;
}
</style>

<template>
  <span>
    <img
      @load="load"
      @click="$modal.show('image-modal', { image: url })"
      :src="url"
      :class="{ 'img-mod': moderation }"
    />
  </span>
</template>

<script>
export default {
  props: ["message", "moderation"],
  computed: {
    url() {
      return `/api/v1/message/media/${this.message.id}`;
    }
  },
  methods: {
    load() {
      this.$bus.$emit("new-message");
      this.$bus.$emit("loaded-image");
    }
  }
};
</script>
